// ================================================================
// PROPRIETARY & CONFIDENTIAL — Miskulin Technologies Inc.
// Copyright (c) 2026 Miskulin Technologies. All rights reserved.
// ================================================================
import React, { useState } from 'react';
import { useAuth } from '../AuthContext';

const COMPETITORS = [
  { id: 1, name: 'CompetitorA Inc', website: 'competitora.ca', da: 42, followers: '8.2K', adSpend: '$3,200/mo', keywords: 34, pricing: '$99-$499/mo' },
  { id: 2, name: 'RivalCo', website: 'rivalco.ca', da: 38, followers: '5.1K', adSpend: '$1,800/mo', keywords: 28, pricing: '$149-$599/mo' },
  { id: 3, name: 'AlternativePro', website: 'altpro.ca', da: 31, followers: '3.4K', adSpend: '$900/mo', keywords: 19, pricing: '$79-$349/mo' },
];

const YOUR_DATA = { name: 'Your Business', da: 38, followers: '10.5K', adSpend: '$3,240/mo', keywords: 47, pricing: 'Custom' };

function CompetitorIntelPage() {
  const { user } = useAuth();
  const [tab, setTab] = useState('overview');

  const renderOverview = () => (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 600, color: 'var(--text)', marginBottom: 16 }}>Competitive Comparison</h2>
      <div style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr 1fr 1fr 1fr 1fr', padding: '12px 20px', background: 'var(--bg)', borderBottom: '1px solid var(--border)', fontSize: 12, fontWeight: 600, color: 'var(--text-muted)', textTransform: 'uppercase' }}>
          <span>Company</span><span>Domain Auth</span><span>Followers</span><span>Ad Spend</span><span>Keywords</span><span>Pricing</span><span>Actions</span>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr 1fr 1fr 1fr 1fr', padding: '14px 20px', borderBottom: '2px solid #6366f1', alignItems: 'center', fontSize: 14, background: 'rgba(99,102,241,0.04)' }}>
          <span style={{ fontWeight: 600, color: '#6366f1' }}>{YOUR_DATA.name} (You)</span>
          <span style={{ fontWeight: 600, color: '#6366f1' }}>{YOUR_DATA.da}</span>
          <span style={{ color: 'var(--text)' }}>{YOUR_DATA.followers}</span>
          <span style={{ color: 'var(--text)' }}>{YOUR_DATA.adSpend}</span>
          <span style={{ color: 'var(--text)' }}>{YOUR_DATA.keywords}</span>
          <span style={{ color: 'var(--text)' }}>{YOUR_DATA.pricing}</span>
          <span />
        </div>
        {COMPETITORS.map(c => (
          <div key={c.id} style={{ display: 'grid', gridTemplateColumns: '1.5fr 1fr 1fr 1fr 1fr 1fr 1fr', padding: '14px 20px', borderBottom: '1px solid var(--border)', alignItems: 'center', fontSize: 14 }}>
            <div><span style={{ fontWeight: 500, color: 'var(--text)' }}>{c.name}</span><br /><span style={{ fontSize: 12, color: 'var(--text-muted)' }}>{c.website}</span></div>
            <span style={{ color: c.da > YOUR_DATA.da ? '#ef4444' : '#10b981', fontWeight: 600 }}>{c.da}</span>
            <span style={{ color: 'var(--text-muted)' }}>{c.followers}</span>
            <span style={{ color: 'var(--text-muted)' }}>{c.adSpend}</span>
            <span style={{ color: c.keywords > YOUR_DATA.keywords ? '#ef4444' : '#10b981' }}>{c.keywords}</span>
            <span style={{ color: 'var(--text-muted)', fontSize: 13 }}>{c.pricing}</span>
            <button style={{ padding: '4px 10px', background: 'transparent', color: '#6366f1', border: '1px solid #6366f1', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>Details</button>
          </div>
        ))}
      </div>
    </div>
  );

  const renderSWOT = () => (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ fontSize: 20, fontWeight: 600, color: 'var(--text)' }}>AI SWOT Analysis</h2>
        <button style={{ padding: '8px 16px', background: 'rgba(99,102,241,0.1)', color: '#6366f1', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer' }}>{'\u2728'} Regenerate</button>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        {[
          { title: 'Strengths', color: '#10b981', items: ['Higher social media following', 'More diverse keyword coverage', 'Competitive pricing flexibility', 'Stronger brand recognition locally'] },
          { title: 'Weaknesses', color: '#ef4444', items: ['Lower domain authority than CompetitorA', 'Less established online presence', 'Smaller review portfolio', 'Limited content marketing'] },
          { title: 'Opportunities', color: '#3b82f6', items: ['Underserved market segments in Alberta', 'Competitor pricing gaps in mid-tier', 'Growing demand for local services', 'Video content is underutilized by all'] },
          { title: 'Threats', color: '#f59e0b', items: ['CompetitorA increasing ad spend', 'New entrants with VC backing', 'Price pressure from AlternativePro', 'Industry consolidation trends'] },
        ].map(section => (
          <div key={section.title} style={{ background: 'var(--card)', border: `1px solid ${section.color}33`, borderRadius: 12, padding: 20, borderTop: `3px solid ${section.color}` }}>
            <h3 style={{ fontSize: 16, fontWeight: 600, color: section.color, marginBottom: 12 }}>{section.title}</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {section.items.map((item, i) => (
                <li key={i} style={{ fontSize: 14, color: 'var(--text)', padding: '6px 0', display: 'flex', gap: 8 }}>
                  <span style={{ color: section.color }}>{'\u2022'}</span> {item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );

  const renderAlerts = () => (
    <div>
      <h2 style={{ fontSize: 20, fontWeight: 600, color: 'var(--text)', marginBottom: 16 }}>Competitor Alerts</h2>
      {[
        { text: 'CompetitorA launched new Facebook ad campaign', time: '2 hours ago', type: 'ad' },
        { text: 'RivalCo updated their pricing page', time: 'Yesterday', type: 'pricing' },
        { text: 'AlternativePro published 3 new blog posts', time: '2 days ago', type: 'content' },
        { text: 'CompetitorA gained 200 new social followers', time: '3 days ago', type: 'social' },
      ].map((a, i) => (
        <div key={i} style={{ background: 'var(--card)', border: '1px solid var(--border)', borderRadius: 10, padding: 16, display: 'flex', alignItems: 'center', gap: 14, marginBottom: 8 }}>
          <span style={{ fontSize: 18 }}>{{ ad: '\uD83D\uDCE3', pricing: '\uD83D\uDCB0', content: '\uD83D\uDCDD', social: '\uD83D\uDC65' }[a.type]}</span>
          <div style={{ flex: 1 }}><p style={{ fontSize: 14, color: 'var(--text)' }}>{a.text}</p></div>
          <span style={{ fontSize: 12, color: 'var(--text-muted)', whiteSpace: 'nowrap' }}>{a.time}</span>
        </div>
      ))}
    </div>
  );

  return (
    <div style={{ padding: '24px 32px', maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ marginBottom: 28 }}>
        <h1 style={{ fontSize: 28, fontWeight: 700, color: 'var(--text)', marginBottom: 6 }}>{'\uD83D\uDD0D'} Competitor Intelligence</h1>
        <p style={{ color: 'var(--text-muted)', fontSize: 15 }}>AI-powered competitive analysis and monitoring.</p>
      </div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        {['overview', 'swot', 'alerts'].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{ padding: '8px 20px', background: tab === t ? '#6366f1' : 'var(--card)', color: tab === t ? '#fff' : 'var(--text-muted)', border: tab === t ? 'none' : '1px solid var(--border)', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer', textTransform: 'capitalize' }}>{t === 'swot' ? 'SWOT Analysis' : t}</button>
        ))}
      </div>
      {tab === 'overview' && renderOverview()}
      {tab === 'swot' && renderSWOT()}
      {tab === 'alerts' && renderAlerts()}
    </div>
  );
}

export default CompetitorIntelPage;
